type EmptyRule = (value: any) => boolean;

export const replaceEmptyFieldsFromObject = <T extends object>(
  target: T,
  replaceValue: Partial<T>,
  isEmpty: EmptyRule = (value) => [null, undefined, ''].includes(value),
): T => {
  const newObj: T = structuredClone(target);

  for (const key in newObj) {
    if (replaceValue[key]) {
      const value = newObj[key];

      if (isEmpty(value)) {
        newObj[key] = replaceValue[key] as T[Extract<keyof T, string>];
      }
    }
  }

  return newObj;
};
